// NOTE: hooks
import { lazy, Suspense, ReactNode } from 'react'
import { useRoutes } from 'react-router-dom'
// NOTE: components
import Loading from './components/ui/Loading'
// NOTE: routes
import clinicianRoutes from './pages/Index'

const Errors = lazy(() => import('./pages/404'))
const Auth = lazy(() => import('./features/auth/Auth'))

interface LoadPageProps {
	page: ReactNode
}

const LoadPage = ({ page }: LoadPageProps) => {
	return <Suspense fallback={<Loading />}>{page}</Suspense>
}

const App = () => {
	const routing = useRoutes([
		...clinicianRoutes,
		{
			path: 'auth',
			element: <LoadPage page={<Auth />} />
		},
		{
			path: '*',
			element: <LoadPage page={<Errors />} />
		}
	])

	return routing
}

export default App
